import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Divider,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useState } from "react";
import styled from "styled-components";
import {
  deletePost,
  getDetailByPublisher,
  matchPassword,
} from "../../services/CustomerAPI";

const HoverDiv = styled.div`
  &:hover {
    color: red;
    cursor: pointer;
  }
`;

export const Complement = (props) => {
  const [inputPassword, setInputPassword] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState(0);
  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setInputPassword("");
    setIsOpen(false);
  };

  const handlePasswordChange = (event) => {
    setInputPassword(event.target.value);
  };

  const confirmMode = () => {
    if (mode === 0) {
      questionBeforeDelete();
    } else {
      questionBeforeEdit();
    }
  };

  const questionBeforeEdit = () => {
    if (inputPassword === "") {
      alert("비밀번호를 입력해주세요!");
      return;
    }

    matchPassword(props.id, inputPassword).then((isPassword) => {
      if (isPassword.data) {
        getDetailByPublisher(props.id, inputPassword).then((response) => {
          props.setDetailComplement(response.data);
          props.setComponentNumber(1);
        });
      } else {
        alert("비밀번호가 일치하지 않습니다!");
        setInputPassword("");
      }
    });
  };

  const questionBeforeDelete = () => {
    if (inputPassword === "") {
      alert("비밀번호를 입력해주세요!");
      return;
    }

    if (window.confirm("정말 삭제하시겠습니까?")) {
      deletePost(props.id, inputPassword).then((res) => {
        confirmResult(res.data);
      });
    } else {
      alert("게시물 삭제를 취소합니다.");
    }
  };

  const confirmResult = (result) => {
    if (result) {
      alert("게시물이 성공적으로 삭제되었습니다.");
      props.goList();
    } else {
      alert("비밀번호가 일치하지 않습니다!");
      setInputPassword("");
    }
  };

  return (
    <>
      <Flex
        mt="20px"
        justifyContent="center"
        justifyItems="center"
        alignContent="center"
        alignItems="center"
        direction="column"
      >
        <Card w="80%" variant="outline">
          <CardBody>
            <Divider />
            <Stack textAlign="center">
              <Text mt="5px" as="b" fontSize="3xl" bgColor="#FFE4E4">
                {props.complement.title}
              </Text>
            </Stack>
            <TableContainer>
              <Table size="sm">
                <Thead h="0">
                  <Tr>
                    <Th
                      w="25%"
                      color="black"
                      textAlign="center"
                      fontSize="xl"
                    ></Th>
                    <Th
                      w="75%"
                      color="black"
                      textAlign="center"
                      fontSize="xl"
                    ></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr w="50%" direction="row">
                    <Td textAlign="center">
                      <Text as="b" fontSize="xl">
                        작성자
                      </Text>
                    </Td>
                    <Td textAlign="start" fontSize="xl">
                      <Text>{props.complement.publisher}</Text>
                    </Td>
                  </Tr>
                  {props.isSecret && (
                    <Tr w="50%" direction="row">
                      <Td textAlign="center">
                        <Text as="b" fontSize="xl">
                          비밀번호
                        </Text>
                      </Td>
                      <Td textAlign="start" fontSize="xl">
                        <Text>{props.complement.publisher}</Text>
                      </Td>
                    </Tr>
                  )}
                  <Tr w="50%" direction="row">
                    <Td textAlign="center">
                      <Text as="b" fontSize="xl">
                        등록일
                      </Text>
                    </Td>
                    <Td textAlign="start">
                      <Text fontSize="xl">
                        {props.complement.createdAt
                          ? props.complement.createdAt.substr(0, 10)
                          : props.complement.createdAt}
                      </Text>
                    </Td>
                  </Tr>
                  <Tr w="50%">
                    <Td textAlign="center">
                      <Text as="b" fontSize="xl">
                        파일
                      </Text>
                    </Td>
                    <Td textAlign="start" fontSize="xl" color="blue">
                      <div>
                        {props.complement.file ? (
                          <HoverDiv>
                            <div>
                              <a
                                href={props.complement.file}
                                target="_blank"
                                download
                                rel="noreferrer"
                              >
                                {props.complement.file.split("/")[4]}
                              </a>
                            </div>
                          </HoverDiv>
                        ) : (
                          <p>등록된 파일 없음</p>
                        )}
                      </div>
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
              <Flex h="250px" p="10px" fontSize="xl">
                <Textarea
                  fontSize="xl"
                  minH="230px"
                  maxH="230px"
                  value={props.complement.content}
                  isReadOnly={true}
                  focusBorderColor="gainsboro"
                ></Textarea>
              </Flex>
              <Divider />
            </TableContainer>
          </CardBody>
        </Card>

        <ButtonGroup mt="10px" justifyContent="center" spacing="3">
          {props.complement.publisher !== "관리자" && (
            <Button
              onClick={() => {
                setMode(0);
                openModal();
              }}
              colorScheme="red"
              size="lg"
              fontSize="2xl"
            >
              삭제
            </Button>
          )}
          {props.complement.publisher !== "관리자" && (
            <Button
              onClick={() => {
                setMode(1);
                openModal();
              }}
              colorScheme="green"
              size="lg"
              fontSize="2xl"
            >
              편집
            </Button>
          )}
          <Button
            onClick={() => props.goList()}
            colorScheme="gray"
            size="lg"
            fontSize="2xl"
          >
            목록
          </Button>
        </ButtonGroup>
      </Flex>

      <Modal
        blockScrollOnMount={false}
        isOpen={isOpen}
        onClose={closeModal}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          justifyContent="center"
          justifyItems="center"
          alignItems="center"
        >
          <ModalHeader textAlign="center">비밀번호 입력</ModalHeader>
          <ModalBody>
            <Input
              name="password"
              type="password"
              value={inputPassword}
              onChange={handlePasswordChange}
            />
          </ModalBody>
          <ModalFooter>
            <ButtonGroup spacing="2">
              <Button colorScheme="gray" onClick={closeModal}>
                취소
              </Button>
              <Button colorScheme="red" onClick={confirmMode}>
                확인
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
